import styled from 'styled-components'
import { DEVICE, BLOCK_MARGIN_TOP } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'

export const ContentGrid = styled(GriddedContentBlock)`
  /* Naming Convenience */
  margin-top: 0;
  padding-bottom: 0;
`

export const FeaturedProductBlock = styled.div`
  grid-column: 2 / 12;
  display: flex;
  flex-direction: column;
  /* gap: 24px; */
`

export const Header = styled.div`
  margin-bottom: 2.4rem;

  @media ${DEVICE.tabletL} {
    margin-bottom: 3.2rem;
  }
`

export const Title = styled.h3`
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.33;
  letter-spacing: 0.02em;
  color: var(--content-background-dark-blue);
  padding-top: 11px;
  margin-bottom: 6px;
`

export const ProductDetailRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.4rem;
`

export const ProductImage = styled.div`
  flex-shrink: 0;
  width: 160px;
  height: 160px;
  overflow: hidden;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    height: 160px;
    width: auto;
    max-width: none;
  }
`

export const ProductTextColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const ProductTitle = styled.span`
  color: var(--highlight-blue);
  h2 {
    font-weight: 600;
    font-size: 1.6rem;
    margin-bottom: 0.9rem;
  }

  @media ${DEVICE.tabletL} {
    h2 {
      font-size: 1.8rem;
    }
  }
`

export const ProductBrand = styled.span`
  color: var(--content-background-dark-blue);
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 0.9rem;
  @media ${DEVICE.tabletL} {
    font-size: 1.8rem;
  }
`

export const ProductDescription = styled.div`
  font-weight: normal;
  font-size: 1.4rem;
  line-height: 1.4;
  color: var(--content-background-dark-blue);

  @media ${DEVICE.tabletL} {
    display: block;
  }

  @media (max-width: 767px) {
    display: none;
  }
`

export const additionalCtaStyles = `
  span {
    font-size: 1.4rem;
    line-height: 1.4;
    padding: 0 14px 0 0;
  }
  @media ${DEVICE.tabletL} {
    span {
      font-size: 1.6rem;
      line-height: 1.6;
      padding: 15px 14px 15px 0;
    }
  }
`
